import React, { useEffect, useState } from "react";
import { MotifFormField, MotifToggleSwitch } from "@ey-xd/motif-react";
import { pursuitLeaderConstants } from "../../../../../constants/pursuitLeaderConstants";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  Now_Next_Beyond_Sidebar_Data_State,
  Pl_Sidebar_Update_Opp_Payload,
  Quaterly_OP_Details_State,
  Recoil_Quarter_State,
  Year_Wise_Data_State,
} from "../../../../../recoil/recoil";
import { QuaterlyDetailsChangeKeys } from "../../../../../util/commonFunctions";
import { isMobile } from "react-device-detect";

const PursuitLeaderToggle = ({
  toggleStatus,
  opp_id,
  tov,
  awd,
  awd_period,
  month,
  fiscal_year,
  onToggleChange,
  isDisabled,
}) => {
  const [isChecked1, setChecked1] = useState(toggleStatus);
  const [labelValue, setLabelValue] = useState(pursuitLeaderConstants.noCommit);
  var [yearQuaterWiseData, setYearQuaterWiseData] =
    useRecoilState(Year_Wise_Data_State);
  var [nowNextBeyondSidebarData, setNowNextBeyondSidebarData] = useRecoilState(
    Now_Next_Beyond_Sidebar_Data_State
  );
  const [plQuaterlyDetails, setPlQuaterlyDetails] = useRecoilState(
    Quaterly_OP_Details_State
  );
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const [commitStatusUpdateOpportunity, setCommitStatusUpdateOpportunity] =
    useRecoilState(Pl_Sidebar_Update_Opp_Payload);

  useEffect(() => {
    // Set labelValue based on the initial state of isChecked1
    setLabelValue(
      isChecked1
        ? pursuitLeaderConstants.commit
        : pursuitLeaderConstants.noCommit
    );
  }, [isChecked1]);

  useEffect(() => {
    if (commitStatusUpdateOpportunity != null) {
      modifySideBarData(commitStatusUpdateOpportunity);
      setCommitStatusUpdateOpportunity(null);
    }
  }, [commitStatusUpdateOpportunity]);

  // Setting opp_id to toggle id OR Creating Unique string for toggle ID
  const ToggleId = opp_id
    ? opp_id
    : `toggleSwitch_${Math.random().toString(36).substring(7)}`;

  let modifySideBarData = (data) => {
    let quarterToUpdate = data.awd_period;
    let monthToUpdate = data.month.toLowerCase();
    let commitValue = data.tov;
    let toggleStatus = data.toggleStatus;
    let fiscalYear = data.fiscal_year;
    let sectionToBeUpdated = null; // NOW, NEXT OR BEYOND
    let modifiedYearQuarterWiseData = nowNextBeyondSidebarData;
    let sectionWiseData = nowNextBeyondSidebarData;
    // Object.freeze(modifiedYearQuarterWiseData);

    for (let key in sectionWiseData) {
      if (sectionWiseData.hasOwnProperty(key)) {
        let perticularSectionData = sectionWiseData[key];
        let quarterData = sectionWiseData[key].quarterInfoData;
        // Object.freeze(quarterData);

        if (quarterData) {
          quarterData.months.forEach((month) => {
            if (
              month.month == monthToUpdate &&
              perticularSectionData?.year == fiscalYear
            ) {
              sectionToBeUpdated = key; // Identifying key to update (ie. NOW, NEXT)
            }
          });
        }
      }
    }

    // If data belongs to BEYOND section
    if (sectionToBeUpdated == null) {
      sectionToBeUpdated = 'BEYOND';
    }

    initModifyNowNextBeyondObject(
      commitValue,
      toggleStatus,
      monthToUpdate,
      sectionToBeUpdated,
      sectionWiseData[sectionToBeUpdated].quarterInfoData, // Having month data
      sectionWiseData[sectionToBeUpdated], // whole single Now, Next, Beyond
      modifiedYearQuarterWiseData, // Object containing Now + Next + Beyond
    );
  };

  let initModifyNowNextBeyondObject = (
    commitValue,
    toggleStatus,
    monthToUpdate,
    sectionToBeUpdated,
    quarterData,
    sectionWiseData,
    modifiedYearQuarterWiseData,
  ) => {
    var newModifiedQuarterData;
    var modifiedMonthData;

    if (quarterData.quarterlyCalculation != null) {
      // for NOW, NEXT section
      let updatedMonths = quarterData.months.map(month => {
        if (month.month === monthToUpdate) {
          if (toggleStatus) {
            modifiedMonthData = {
              month: monthToUpdate,
              calculation: {
                ...month.calculation,
                commit: month.calculation.commit + commitValue,
                noCommit: month.calculation.noCommit - commitValue,
                forecast:
                  quarterInfo.current_month_start_date == quarterInfo.quarter_start_date
                    ? month.calculation.forecast + commitValue
                    : month.calculation.forecast,
              },
            };
          } else {
            modifiedMonthData = {
              month: monthToUpdate,
              calculation: {
                ...month.calculation,
                commit: month.calculation.commit - commitValue,
                noCommit: month.calculation.noCommit + commitValue,
                forecast:
                  quarterInfo.current_month_start_date == quarterInfo.quarter_start_date
                    ? month.calculation.forecast - commitValue
                    : month.calculation.forecast,
              },
            };
          }
          return modifiedMonthData;
        }
        return month;
      });

      if (toggleStatus) {
        newModifiedQuarterData = {
          ...quarterData,
          quarterlyCalculation: {
            ...quarterData.quarterlyCalculation,
            commit: quarterData.quarterlyCalculation.commit + commitValue,
            noCommit: quarterData.quarterlyCalculation.noCommit - commitValue,
            forecast:
              quarterInfo.current_month_start_date == quarterInfo.quarter_start_date
                ? quarterData.quarterlyCalculation.forecast + commitValue
                : quarterData.quarterlyCalculation.forecast,
          },
          months: updatedMonths,
        };
      } else {
        newModifiedQuarterData = {
          ...quarterData,
          quarterlyCalculation: {
            ...quarterData.quarterlyCalculation,
            commit: quarterData.quarterlyCalculation.commit - commitValue,
            noCommit: quarterData.quarterlyCalculation.noCommit + commitValue,
            forecast:
              quarterInfo.current_month_start_date == quarterInfo.quarter_start_date
                ? quarterData.quarterlyCalculation.forecast - commitValue
                : quarterData.quarterlyCalculation.forecast,
          },
          months: updatedMonths,
        };
      }
    } else {
      // for BEYOND section
      let updatedMonths = quarterData.months.map(month => {
        if (month.month === month.month) {
          if (toggleStatus) {
            modifiedMonthData = {
              month: month.month,
              calculation: {
                ...month.calculation,
                commit: month.calculation.commit + commitValue,
                noCommit: month.calculation.noCommit - commitValue,
                forecast:
                  quarterInfo.current_month_start_date == quarterInfo.quarter_start_date
                    ? month.calculation.forecast + commitValue
                    : month.calculation.forecast,
              },
            };
          } else {
            modifiedMonthData = {
              month: month.month,
              calculation: {
                ...month.calculation,
                commit: month.calculation.commit - commitValue,
                noCommit: month.calculation.noCommit + commitValue,
                forecast:
                  quarterInfo.current_month_start_date == quarterInfo.quarter_start_date
                    ? month.calculation.forecast - commitValue
                    : month.calculation.forecast,
              },
            };
          }
          return modifiedMonthData;
        }
        return month;
      });

      newModifiedQuarterData = {
        ...quarterData,
        quarterlyCalculation: null,
        months: updatedMonths,
      };
    }

    let updatedQuarterWiseData = {
      ...modifiedYearQuarterWiseData,
      [sectionToBeUpdated]: { ...sectionWiseData, quarterInfoData: newModifiedQuarterData },
    };

    setNowNextBeyondSidebarData(updatedQuarterWiseData);
  };

  let setPlPostData = value => {
    const crm_quaterly_response = QuaterlyDetailsChangeKeys(plQuaterlyDetails);
    onToggleChange(value, crm_quaterly_response);
  };

  return (
    <div style={{ marginTop: 12, marginLeft: -5 }}>
      <MotifFormField>
        <MotifToggleSwitch
          checked={isChecked1}
          onChange={event => {
            setChecked1(event.target.checked);
            setPlPostData(event.target.checked);
            modifySideBarData({
              toggleStatus: event.target.checked,
              opp_id: opp_id,
              tov: tov,
              awd: awd,
              awd_period: awd_period,
              fiscal_year: fiscal_year,
              month: month,
            });
          }}
          on
          id={ToggleId}
          onLabel={!isMobile ? labelValue : ''}
          offLabel=""
          disabled={isDisabled}
        />
      </MotifFormField>
    </div>
  );
};
export default PursuitLeaderToggle;
